@let showComponent = showComponent$ | async;
@if (showComponent) {
  <form [formGroup]="form">
    @let fieldSettings = fieldsSettings$ | async;

    <ion-list lines="full" [inset]="true" class="no-last-line">
      <ion-list-header>Property Taxes / HOA</ion-list-header>
      @if (fieldSettings?.['taxes']?.visible) {
        <ion-item>
          <ion-input
            redErrorMessage
            formControlName="taxes"
            labelPlacement="stacked"
            placeholder="$ / %"
            inputmode="decimal"
            type="text"
            [maskito]="rateAmountMask"
            [maskitoElement]="maskPredicate"
          >
            <div slot="label" class="tw:whitespace-normal">Property Taxes</div>
          </ion-input>
        </ion-item>
      }

      @if (fieldSettings?.['taxesTerm']?.visible) {
        <ion-item>
          <ion-select
            redErrorMessage
            formControlName="taxesTerm"
            labelPlacement="stacked"
            [interfaceOptions]="{ header: 'Select tax term' }"
          >
            <div slot="label" class="tw:whitespace-normal">Property Taxes Term</div>
            @for (tax of availableTaxesTerms; track tax) {
              <ion-select-option [value]="tax">{{ tax }}</ion-select-option>
            }
          </ion-select>
        </ion-item>
      }

      @if (fieldSettings?.['taxesPaidToDatePicker']?.visible) {
        <ion-item>
          <ion-input
            redErrorMessage
            formControlName="taxesPaidToDatePicker"
            labelPlacement="stacked"
            placeholder="mm/dd/yyyy"
            inputmode="text"
            type="text"
            (click)="onDatePickerInputClick($event, 'taxesPaidToDatePicker')"
            [readonly]="true"
          >
            <div slot="label" class="tw:whitespace-normal">Property Taxes Paid To Date</div>
          </ion-input>
        </ion-item>
      }

      @if (fieldSettings?.['taxesPaidToDateDropdown']?.visible) {
        <ion-item>
          <ion-select
            redErrorMessage
            formControlName="taxesPaidToDateDropdown"
            labelPlacement="stacked"
            placeholder="mm/dd/yyyy"
            [interfaceOptions]="{ header: 'Select date' }"
          >
            <div slot="label" class="tw:whitespace-normal">Property Taxes Paid To Date</div>

            @let taxesPaidToDateDropdownData = taxesPaidToDateDropdownData$ | async;
            @for (date of taxesPaidToDateDropdownData; track date) {
              <ion-select-option [value]="date">{{ date }}</ion-select-option>
            }
          </ion-select>
        </ion-item>
      }

      @if (fieldSettings?.['taxesPaid']?.visible) {
        <ion-item-divider> Property Tax Status: </ion-item-divider>

        <ion-radio-group formControlName="taxesPaid">
          <ion-item>
            <ion-radio class="tw:text-xs" [value]="true">Paid</ion-radio>
          </ion-item>
          <ion-item>
            <ion-radio class="tw:text-xs" [value]="false">Unpaid</ion-radio>
          </ion-item>
        </ion-radio-group>
      }

      @if (fieldSettings?.['taxesNextInstallment']?.visible) {
        <ion-item>
          <ion-input
            redErrorMessage
            formControlName="taxesNextInstallment"
            labelPlacement="stacked"
            placeholder="$"
            inputmode="decimal"
            type="text"
            [maskito]="amountMask"
            [maskitoElement]="maskPredicate"
          >
            <div slot="label" class="tw:whitespace-normal">Property Taxes Next Installment</div>
          </ion-input>
        </ion-item>
      }

      @if (fieldSettings?.['taxesHomeownersDuesAmount']?.visible) {
        <ion-item>
          <ion-input
            redErrorMessage
            formControlName="taxesHomeownersDuesAmount"
            labelPlacement="stacked"
            placeholder="$"
            inputmode="decimal"
            type="text"
            [maskito]="amountMask"
            [maskitoElement]="maskPredicate"
          >
            <div slot="label" class="tw:whitespace-normal">HOA</div>
          </ion-input>
        </ion-item>
      }

      @if (fieldSettings?.['taxesHomeownersDuesDueDate']?.visible) {
        <ion-item>
          <ion-input
            redErrorMessage
            formControlName="taxesHomeownersDuesDueDate"
            labelPlacement="stacked"
            placeholder="mm/dd/yyyy"
            inputmode="text"
            type="text"
            (click)="onDatePickerInputClick($event, 'taxesHomeownersDuesDueDate')"
            [readonly]="true"
          >
            <div slot="label" class="tw:whitespace-normal">HOA Due Date</div>
          </ion-input>
        </ion-item>
      }

      @if (fieldSettings?.['taxesHomeownersDuesTerm']?.visible) {
        <ion-item>
          <ion-select
            redErrorMessage
            labelPlacement="stacked"
            formControlName="taxesHomeownersDuesTerm"
            [interfaceOptions]="{ header: 'Select due term' }"
          >
            <div slot="label" class="tw:whitespace-normal">HOA Paid</div>
            @for (term of availableHomeownersDuesTerms; track term) {
              <ion-select-option [value]="term">{{ term }}</ion-select-option>
            }
          </ion-select>
        </ion-item>
      }

      @if (fieldSettings?.['taxesHomeownersDuesPaid']?.visible) {
        <ion-item-divider> Homeowners Dues Status: </ion-item-divider>
        <ion-radio-group formControlName="taxesHomeownersDuesPaid">
          <ion-item>
            <ion-radio class="tw:text-xs" [value]="true">Paid</ion-radio>
          </ion-item>
          <ion-item>
            <ion-radio class="tw:text-xs" [value]="false">Unpaid</ion-radio>
          </ion-item>
        </ion-radio-group>
      }
    </ion-list>
  </form>
}
